export const typeContratAvenant = Object.freeze([
  'ModificationSituationEmployeur',
  'ChangementEmployeurSaisonnier',
  'ProlongationSuiteEchecExamen',
  'ProlongationSuiteReconnaissanceHandicap',
  'DiplomeSupplementaireApprenti',
  'AutresChangements',
  'ModificationLieuExecutionContrat',
  'ModificationLieuFormationTheorique',
])
export const typeContratSuccessionContrat = Object.freeze([
  'NouveauContratMemeEmployeur',
  'NouveauContratAutreEmployeur',
  'NouveauContratPrecedentRompu',
])

export const typeContratAvenantRncp = Object.freeze([
  'NouveauContratPrecedentRompu',
  'ModificationSituationEmployeur',
  'ChangementEmployeurSaisonnier',
  'AutresChangements',
])

export const minimumRemunerationCap = {
  Moins18: {
    annee1: 0.27,
    annee2: 0.39,
    annee3: 0.55,
  },
  Moins21: {
    annee1: 0.43,
    annee2: 0.51,
    annee3: 0.67,
  },
  Moins26: {
    annee1: 0.53,
    annee2: 0.61,
    annee3: 0.78,
  },
  Plus25: {
    annee1: 1,
    annee2: 1,
    annee3: 1,
  },
} as const

export const anneeChangementMinimumSmic = Object.freeze([18, 21, 26])

export const typesContratEligiblesMajoration10 = Object.freeze([
  'PremierContratApprentissage',
  'NouveauContratMemeEmployeur',
  'NouveauContratAutreEmployeur',
])
